import React from 'react';
import PropTypes from 'prop-types';

import LocaleContext from './LocaleContext';

const LocaleProvider = ({ locale, children }) => (
  <LocaleContext value={locale}>{children}</LocaleContext>
);

LocaleProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default LocaleProvider;
